import type { FaireProductEntity } from "../../entity_types/product";

export const p_ha9kzua573: FaireProductEntity = {
  token: "p_ha9kzua573",
  type: "product",
  name: "Latte Love Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a2fb07a518750a82bf5d89020ab38c7555ad90a37a2990104997f5cca58ab9f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cedf57499319922c7b23f1928c00a00d47337b2f0954b05a07472886f2f675a9.jpeg",
    "https://cdn.faire.com/fastly/d88c52d79156526350a0269311fa86d77c05cf8b6caa7798a2de2a7c543561c0.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:25.780Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
